import { Download } from "lucide-react";
import type { Metadata } from "@/lib/head";

import ToolIntro from "@/pages/tools/_ui/tool-intro";
import { Button } from "@buildpy/ui/button";
import A4Fit from "@/modules/print/a4-fit";
import BlankQuoteForm from "@/modules/print/blank-quote-form";
import PrintButton from "@/modules/print/print-button";
import { QUOTE_TEMPLATE_HEADERS } from "@buildpy/core/modules/tools/quote-template";

export const metadata: Metadata = {
  title: "인테리어 견적서 양식 (엑셀·인쇄) — 무료 다운로드",
  description:
    "인테리어 공사 견적서 빈 양식. 공종·공간·작업내역·단위·수량·자재/노무 단가 열의 엑셀 양식을 내려받거나 바로 인쇄하세요. 채운 엑셀은 buildpy(빌드파이) 견적으로 그대로 가져옵니다.",
};

// 빈 견적서 — 인쇄용 한 장과 엑셀 양식(가져오기와 같은 머리글).
const QuoteFormPage = () => (
  <div className="flex flex-col gap-4">
    <ToolIntro
      actions={
        <>
          <Button asChild size="sm" variant="outline">
            <a download href="/api/tools/forms/quote/xlsx">
              <Download />
              엑셀 양식 받기
            </a>
          </Button>
          <PrintButton label="양식 인쇄" />
        </>
      }
      description={`엑셀 열: ${QUOTE_TEMPLATE_HEADERS.join(" · ")} — 예시 3줄이 들어 있습니다. 채운 파일은 buildpy 견적의 「엑셀 가져오기」로 그대로 올라갑니다.`}
      title="인테리어 견적서 양식"
    />
    <div className="print-root">
      <A4Fit>
        <BlankQuoteForm />
      </A4Fit>
    </div>
  </div>
);

export default QuoteFormPage;
